import { gql } from "@apollo/client"

export const GET_ASSIGNMENTS = gql`
  query getAssignmentsList($data: GetAssignmentsListRequest!) {
    assignments {
      getList(data: $data) {
        assignments {
          id
          name
          contentType
          contentId
          open
          close
          due
          settings
          status
          districtId
          schoolId
          updated_by
          updated_at
          created_by
          created_at
          assignees {
            type
            id
            name
          }
          percentComplete
          averageScore
        }
        pageCount
      }
    }
  }
`

export const GET_ASSIGNMENT_RECORD = gql`
  query getAssignmentRecord($data: GetAssignmentRecordRequest!) {
    assignments {
      getRecord(data: $data) {
        summary {
          assignmentId
          assignmentName
          contentType
          contentId
          assignees {
            type
            id
            name
          }
          status
          open
          close
          due
          allowLate
          program
          subject
        }
        widgets {
          total
          completed
          inProgress
          notStarted
          completedPercent
          inProgressPercent
          notStartedPercent
          percentComplete
          averageAccuracy
        }
        students {
          studentId
          studentName
          classNames
          status
          completedAt
          percentComplete
          accuracy
        }
        totalCount
        pageCount
      }
    }
  }
`

export const DOWNLOAD_ASSIGNMENT_RECORD_STUDENTS = gql`
  query downloadAssignmentRecordStudents(
    $data: DownloadAssignmentRecordStudentsRequest!
  ) {
    assignments {
      downloadRecordStudents(data: $data) {
        output
      }
    }
  }
`
